import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import i18n from './i18n';

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction='down' in={!trigger}>
      {children}
    </Slide>
  );
}

const NAV_LINKS = [
  { to: '/',      labelKey: 'nav.home'        },
  { to: '/music', labelKey: 'nav.music'       },
  { to: '/store', labelKey: 'nav.merch_store' },
  { to: '/about', labelKey: 'nav.about'       },
];

function NavBar() {
  const { t } = useTranslation();
  const location = useLocation();

  const [nextLang, setNextLang] = React.useState(
    i18n.language === 'fr' ? 'EN' : 'FR'
  );

  const handleLanguageChange = () => {
    const switchTo = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(switchTo);
    setNextLang(switchTo === 'fr' ? 'EN' : 'FR');
  };

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <HideOnScroll>
      <AppBar>
        <Toolbar className='nav' disableGutters>
          <div className='navScroll'>
            {NAV_LINKS.map(({ to, labelKey }) => (
              <Link key={to} className='noDeco' to={to}>
                <Typography
                  variant='h6'
                  component='div'
                  className={`navItems${isActive(to) ? ' navActive' : ''}`}
                >
                  {t(labelKey)}
                </Typography>
              </Link>
            ))}
            <span onClick={handleLanguageChange} className='navLang'>
              {nextLang}
            </span>
          </div>
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  );
}

export default NavBar;
